
import React from 'react';
import KnowledgeBasePage from '@/components/knowledge/KnowledgeBasePage';

const KnowledgeBase = () => {
  return <KnowledgeBasePage />;
};

export default KnowledgeBase;
